import { ComponentRenderer } from 'app/src/features/UserAccount/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { NavigatePaths, useComponentRenderer, usePageTitle, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

/**
 * Functional component representing the User Account page.
 * If child routes are active, it renders them via Outlet shadowing parent content.
 * @returns ReactElement The User Account page component.
 */
export function UserAccount(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const userAccountPageConfig = pageconfigurationsApi.usePageRequestGet({
    pathParams: { id: 'useraccountpage', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })
  const { t } = useTranslation('home')
  usePageTitle(t('AppBar.UserAccount'))
  useEffect(() => {
    context.update({ breadCrumbItems: [] })

    //evita loop su contesto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { pathname } = useLocation()

  return (
    <>
      <div hidden={pathname !== NavigatePaths.UserAccount}>
        <PageWidget containerClassNamesOverrides='mb-1'>
          <h1 className='text-3xl font-bold'>{t('AppBar.UserAccount')}</h1>
        </PageWidget>
        {ComponentRenderer(getPage(userAccountPageConfig?.data))}
      </div>
      <Outlet />
    </>
  )
}
